import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import AccountInformation from '../../../common/AccountInformation';
import { OuterContainer } from '../DashboardOuterContainerPagesLayout';
import { AccessResource, useHasAccess } from '../../../common/hooks/useHasAccess';
import { Notfound } from '../../NotFound';

export default function AccountSettings() {
  const { t } = useTranslation();
  const theme = useTheme();

  const hasAccountSettingsPageAccess = useHasAccess(AccessResource.AccountSettingsPage);

  if (!hasAccountSettingsPageAccess) {
    return <Notfound />;
  }

  return (
    <OuterContainer
      sx={{
        gap: theme.spacing(5),
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        p: `${theme.spacing(4)} ${theme.spacing(0)} ${theme.spacing(4)} ${theme.spacing(0)}`,
        [theme.breakpoints.down('sm')]: {
          gap: theme.spacing(2.5),
          background: 'transparent',
          border: theme.spacing(0),
          padding: theme.spacing(0),
        },
      }}
    >
      <>
        <Typography variant="h12">
          {t('navigation.settings')}
        </Typography>
        <AccountInformation />
      </>
    </OuterContainer>
  );
}
